export const ru = {
    active: 'Идет сбор данных.',
    'active-grid': 'Сбор данных',
    'active-text':
        'Доступны промежуточные результаты, они могут отличаться от финальных результатов.',
    'and-grid': 'и',
    'budget-grid': 'бюджет',
    completed: 'Опрос завершен.',
    'completed-grid': 'Завершено',
    'coverage-grid': 'охват',
    draft: 'Черновик.',
    'draft-grid': 'Черновик',
    'draft-text':
        'Сбор данных начнётся после того, как исследование пройдёт модерацию.',
    'low-grid': 'недостаточный {reason}',
    moderation: 'Отправлено на модерацию.',
    'moderation-grid': 'На модерации',
    'moderation-text':
        'Сбор данных начнётся после того, как исследование пройдёт модерацию.',
    'not-brand-grid': 'исследуемый бренд не ясен',
    reject: 'Исследование отклонено модерацией.',
    'reject-grid': 'Отклонено модерацией',
    save: 'Сохранить',
    'show-params-grid': 'посмотреть параметры',
    'show-result-grid': 'доступны результаты',
    stop: 'Опрос остановлен.',
    'stop-active': 'Исследование Brand Lift остановлено:',
    'stop-active-budget': 'бюджет кампании меньше 500 000 рублей.',
    'stop-active-budget-and-coverage':
        'Бюджет кампании меньше 500 000 рублей и охват кампании меньше 2 млн.',
    'stop-active-coverage': 'охват кампании меньше 2 млн.',
    'stop-budget':
        'Бюджета кампании недостаточно для проведения Brand Lift. Увеличьте бюджет до 500 000 рублей.',
    'stop-budget-and-coverage':
        'Бюджета и охвата кампании недостаточно для проведения Brand Lift. Измените условия нацеливания, чтобы прогнозируемый охват был не менее 2 млн, и увеличьте бюджет до 500 000 рублей.',
    'stop-coverage':
        'Охвата кампании недостаточно для проведения Brand Lift. Измените условия нацеливания, чтобы прогнозируемый охват был не менее 2 млн.',
    'stop-grid': 'Остановлено'
};
